/* eslint-disable react-hooks/exhaustive-deps */
import AppView from "./views/AppView/AppView";

function App() {
    return <AppView/>;
}

export default App;
